/* unplugin-vue-components disabled */import script from "./Record.vue?vue&type=script&setup=true&lang=ts"
export * from "./Record.vue?vue&type=script&setup=true&lang=ts"

import "./Record.vue?vue&type=style&index=0&id=79242b34&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79242b34"]])

export default __exports__